import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/app/blog/category/[slug]/CategoryPageClient.tsx");
